/**
 * LOP — Memorial Day Sale label on PLP product cards.
 * Per-color only: swatch data-memorial-day-sale-color + visible sale on that swatch/card.
 *
 * Debug: window.LOP_DEBUG_MEMORIAL_DAY_SALE = true  then reload
 */
(function () {
  'use strict';

  var BOOT_MSG = '[LOP memorial day] PLP script loaded — set window.LOP_DEBUG_MEMORIAL_DAY_SALE = true for verbose logs';

  function debug() {
    if (window.LOP_DEBUG_MEMORIAL_DAY_SALE) {
      console.log.apply(console, ['[LOP memorial day]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  function cardHasVisibleSalePrice(card) {
    var priceContainer = card.querySelector('.product-item__price');
    return priceContainer ? !!priceContainer.querySelector('s') : false;
  }

  function getImageFilename(url) {
    if (!url) return '';
    return url.split('?')[0].split('/').pop();
  }

  function findActiveSwatch(card) {
    var swatches = card.querySelectorAll('.product-swatches-options__item--swatch');
    if (!swatches.length) return null;

    var targetColor = card.getAttribute('data-b4b-color') || card.getAttribute('data-lop-current-color');
    if (targetColor) {
      for (var i = 0; i < swatches.length; i++) {
        if (swatches[i].getAttribute('data-option-value') === targetColor) {
          return swatches[i];
        }
      }
    }

    var currentVariantId = card.getAttribute('data-current-variant-id');
    if (currentVariantId) {
      for (var j = 0; j < swatches.length; j++) {
        if (swatches[j].getAttribute('data-variant-id') === currentVariantId) {
          return swatches[j];
        }
      }
    }

    var img = card.querySelector('.product-item__gallery-images-wrap img, .product-item__image-link img, .product-item__media img');
    if (img && img.src) {
      var currentFilename = getImageFilename(img.src);
      for (var k = 0; k < swatches.length; k++) {
        var swatchImageUrl = swatches[k].getAttribute('data-variant-image-url');
        if (swatchImageUrl && getImageFilename(swatchImageUrl) === currentFilename) {
          return swatches[k];
        }
      }
    }

    return null;
  }

  function shouldShowForSwatch(card, swatch) {
    if (!swatch) return false;

    var colorHasMemorial = swatch.getAttribute('data-memorial-day-sale-color') === 'true';
    if (!colorHasMemorial) {
      return card.getAttribute('data-lop-show-memorial-day-sale') === 'true' && cardHasVisibleSalePrice(card);
    }

    var swatchOnSale = !!swatch.getAttribute('data-variant-compare-at-price');
    var cardOnSale = cardHasVisibleSalePrice(card);
    return swatchOnSale || cardOnSale;
  }

  function updateBadge(card, swatch) {
    var badge = card.querySelector('[data-memorial-day-sale-badge]');
    if (!badge) return;

    var label = badge.getAttribute('data-lop-memorial-label') || badge.textContent.trim();
    if (label && !badge.getAttribute('data-lop-memorial-label')) {
      badge.setAttribute('data-lop-memorial-label', label);
    }

    var show = shouldShowForSwatch(card, swatch);
    badge.classList.toggle('hidden', !show);
    if (label) {
      badge.textContent = show ? label : '';
    }

    debug(card.getAttribute('data-handle') || card.querySelector('[data-handle]'), {
      color: swatch ? swatch.getAttribute('data-option-value') : null,
      variantId: swatch ? swatch.getAttribute('data-variant-id') : null,
      memorialColor: swatch ? swatch.getAttribute('data-memorial-day-sale-color') : null,
      swatchOnSale: swatch ? !!swatch.getAttribute('data-variant-compare-at-price') : false,
      cardOnSale: cardHasVisibleSalePrice(card),
      liquidInitial: card.getAttribute('data-lop-show-memorial-day-sale'),
      show: show
    });
  }

  function syncCard(card, swatch) {
    if (!card) return;
    var activeSwatch = swatch || findActiveSwatch(card);
    if (!activeSwatch) {
      var liquidInitial = card.getAttribute('data-lop-show-memorial-day-sale') === 'true';
      var badge = card.querySelector('[data-memorial-day-sale-badge]');
      if (badge) {
        var label = badge.getAttribute('data-lop-memorial-label') || '';
        badge.classList.toggle('hidden', !liquidInitial);
        badge.textContent = liquidInitial ? label : '';
      }
      debug(card.getAttribute('data-handle'), { noSwatches: true, liquidInitial: liquidInitial, show: liquidInitial });
      return;
    }
    updateBadge(card, activeSwatch);
  }

  function syncAll() {
    var cards = document.querySelectorAll('.product-item');
    debug('syncAll', cards.length, 'cards');
    cards.forEach(function (card) {
      syncCard(card);
    });
  }

  function scheduleSync() {
    clearTimeout(scheduleSync._t);
    scheduleSync._t = setTimeout(syncAll, 80);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.product-swatches-options__item--swatch');
    if (!sw) return;
    var card = sw.closest('.product-item');
    if (!card) return;
    setTimeout(function () {
      syncCard(card, sw);
    }, 50);
  }, true);

  function boot() {
    console.log(BOOT_MSG);
    syncAll();
    [150, 400, 800, 1500, 3500].forEach(function (ms) {
      setTimeout(syncAll, ms);
    });

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        var relevant = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'characterData') {
            var p = m.target && m.target.parentElement;
            if (p && p.closest && p.closest('.product-item__price')) {
              relevant = true;
              break;
            }
          }
          if (m.type === 'childList') {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var n = m.addedNodes[j];
              if (n.nodeType !== 1) continue;
              if ((n.matches && n.matches('.product-item')) || (n.querySelector && n.querySelector('.product-item'))) {
                relevant = true;
                break;
              }
            }
          }
        }
        if (relevant) scheduleSync();
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (typeof window.LOP_SYNC_B40_STRIKETHROUGH === 'function') {
      hookB40Sync();
    } else {
      setTimeout(hookB40Sync, 200);
      setTimeout(hookB40Sync, 1000);
    }

    document.addEventListener('shopify:section:load', scheduleSync);
  }

  function hookB40Sync() {
    if (typeof window.LOP_SYNC_B40_STRIKETHROUGH !== 'function') return;
    if (window.LOP_SYNC_B40_STRIKETHROUGH.__lopMemorialHooked) return;
    var origB40 = window.LOP_SYNC_B40_STRIKETHROUGH;
    window.LOP_SYNC_B40_STRIKETHROUGH = function () {
      origB40();
      scheduleSync();
    };
    window.LOP_SYNC_B40_STRIKETHROUGH.__lopMemorialHooked = true;
  }

  window.LOPMemorialDaySale = {
    sync: syncCard,
    syncAll: syncAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
